import { apiNotifications } from "@/api/notification.api.ts";
import { ApiErrorException } from "@/types/api.types.ts";
import { ApiNotificationsFilter } from "@/types/notification.types.ts";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQuery } from "@tanstack/react-query";

export const notificationsKeys = createQueryKeys("notifications", {
  search: (filter: ApiNotificationsFilter) => ({
    queryKey: [filter],
    queryFn: async ({ signal }) => {
      const result = await apiNotifications.searchNotifications(filter, signal);
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
  }),
});

export const useNotifications = (filter: ApiNotificationsFilter, enabled = true) => {
  return useQuery({
    ...notificationsKeys.search(filter),
    enabled: enabled,
  });
};
